import { Injectable, PLATFORM_ID, inject, signal } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

const STORAGE_KEY = 'jagannath-theme';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly isBrowser = isPlatformBrowser(this.platformId);

  readonly darkMode = signal(this.readPreference());

  constructor() {
    if (this.isBrowser) {
      this.apply(this.darkMode());
    }
  }

  setDarkMode(enabled: boolean): void {
    this.darkMode.set(enabled);
    if (this.isBrowser) {
      localStorage.setItem(STORAGE_KEY, enabled ? 'dark' : 'light');
      this.apply(enabled);
    }
  }

  toggle(): void {
    this.setDarkMode(!this.darkMode());
  }

  private readPreference(): boolean {
    if (!this.isBrowser) {
      return false;
    }

    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'dark') return true;
    if (stored === 'light') return false;

    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  }

  private apply(dark: boolean): void {
    document.documentElement.classList.toggle('dark-mode', dark);

    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) {
      meta.setAttribute('content', dark ? '#0f172a' : '#f8f9fa');
    }
  }
}